import React from "react";
import { Body, Headline } from "sunday-component";
import { Trans, useTranslation } from "react-i18next";
import { color } from "src/styles/globals";
import styled from "styled-components";
import {
  FlexVerticalContainer,
  SectionContainer,
} from "./style/AffiliatePage.style";

const Description = styled(Body).attrs({ level: 7 })`
  color: ${color.charcoal09};
`;

const AffiliateDescription = () => {
  const { t } = useTranslation("affiliate");
  return (
    <SectionContainer id="start-register">
      <FlexVerticalContainer rowGap="8px">
        <Headline level={4}>{t("main.title")}</Headline>
        <Description>
          <Trans>{t("main.subTitle")}</Trans>
        </Description>
      </FlexVerticalContainer>
    </SectionContainer>
  );
};

export default AffiliateDescription;
